import { render, staticRenderFns } from "./document-page.vue?vue&type=template&id=4317badb&scoped=true&"
import script from "./document-page.js?vue&type=script&lang=js&"
export * from "./document-page.js?vue&type=script&lang=js&"
import style0 from "./document-page.scss?vue&type=style&index=0&id=4317badb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4317badb",
  null
  
)

export default component.exports